import { call, put, takeEvery } from "redux-saga/effects"
// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes"
import { apiError } from "./actions"

//Include Both Helper File with needed methods
import { auth } from "helpers/api_helper"

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(auth, "login", {
      email: user.email,
      password: user.password,
    })
    localStorage.setItem("authUser", JSON.stringify(response.data))
    window.location.href = "/"
  } catch (error) {
    if (error.status === 401) {
      yield put(apiError(error.data.message))
    }
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")
    history.push("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
